import React, { useEffect, useRef, useState } from "react";
import BackgroundSection from "components/BackgroundSection/BackgroundSection";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useSelector } from "react-redux";
import services from "utils/services";
import dayjs, { Dayjs } from "dayjs";

import Select from "shared/Select/Select";
import { Shift } from "data/data";
// import { saveFilters } from "redux/reducers/auth";
import { avatarColors, MONTH_DISPLAY } from "contains/contants";

import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat"; // ES 2015
import weekOfYear from "dayjs/plugin/weekOfYear";
import updateLocale from "dayjs/plugin/updateLocale";

import "dayjs/locale/fr";

import { CheckIcon, InformationCircleIcon } from "@heroicons/react/24/outline";
import { useAuth } from "provider/useAuth";
import ModalCongesRecup from "components/ModalCongesRecup";
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(weekOfYear);
dayjs.locale("fr");
dayjs.extend(updateLocale);

dayjs.updateLocale("fr", {
	weekStart: 1,
});

function EmployeePlanning() {
	const authContext = useAuth();

	const today = useRef(dayjs().startOf("month"));

	const [plannings, setPlannings] = useState<any>({});
	const [employee, setEmployee] = useState<any>(null);
	const [shifts, setShifts] = useState<Shift[]>([]);
	const [selectedMonth, setSelectedMonth] = useState(today.current.month());
	const [selectedYear, setSelectedYear] = useState(today.current.year());
	const [dayList, setDayList] = useState<any>([]);
	const [yearList, setYearList] = useState<any>([]);
	const [monthList, setMonthList] = useState<any>([]);

	const [showModalCongesRecup, setShowModalCongesRecup] = useState(false);

	useEffect(() => {
		getShifts();
		getEmployee();
		getPlannings("", "");
	}, []);

	useEffect(() => {
		const monthList: any = [];
		const years: any = [];
		const currentDay = dayjs();

		// const lastMonthToShow = currentDay.add(3, "month");
		for (let y = 2025; y <= currentDay.year(); y++) {
			years.push(y);
		}

		// let firstMonth = dayjs("2025-01-01");
		// if (selectedYear == 2025) {
		// 	firstMonth = firstMonth.set("month", 9);
		// }

		if (plannings && Object.keys(plannings).length > 0) {
			Object.values(plannings).forEach((planning: any) => {
				const year = dayjs(planning.startDate).year();
				const month = dayjs(planning.startDate).month();
				if (!years.includes(year)) {
					years.push(year);
				}
				if (
					selectedYear == year &&
					!monthList.find((m: any) => m.value == month)
				) {
					if (year == 2025 && month < 9) return;
					monthList.push({
						value: month,
						label: dayjs().set("month", month).format("MMMM"),
					});
				}
			});
		}

		// const firstMonthNum = firstMonth.get("month");
		// const lastMonthNum = 11;
		// // currentDay.year() == selectedYear ? lastMonthToShow.month() : 11;
		// for (let y = firstMonthNum; y <= lastMonthNum; y++) {
		// 	monthList.push({
		// 		value: firstMonth.get("month"),
		// 		label: firstMonth.format("MMMM"),
		// 	});
		// 	firstMonth = firstMonth.add(1, "month");
		// }
		setYearList(years);
		setMonthList(monthList);
		setSelectedMonth(monthList[0] ? monthList[0].value : today.current.month());
		onChangePeriod();
	}, [plannings, selectedYear]);

	useEffect(() => {
		onChangePeriod();
	}, [selectedMonth]);

	const getEmployee = () => {
		services.getOneUser(
			authContext.user._id,
			(success) => {
				setEmployee(success.user);
			},
			(error) => {}
		);
	};

	const getShifts = () => {
		services.getShifts(
			{},
			(res) => {
				const shifts = res.shifts;
				shifts.forEach((s: any, ind: number) => (s.color = avatarColors[ind]));
				setShifts(shifts);
			},
			(err) => {
				console.error(err);
			}
		);
	};

	const getPlannings = (dateFrom: string = "", dateTo: string = "") => {
		// updateFilters();
		services.getEmployeePlanning(
			{
				dateFrom,
				dateTo,
				displayType: MONTH_DISPLAY.value,
			},
			(success) => {
				setPlannings(success.plannings);
			},
			(error) => {
				console.error(error);
			}
		);
	};

	// useEffect(() => {
	// 	if (displayType == MONTH_DISPLAY.value) {
	// 		today.current = today.current.startOf("month");
	// 	} else {
	// 		today.current = dayjs();
	// 	}

	// 	onChangePeriod();
	// }, [displayType]);
	// useEffect(() => {
	// 	onChangePeriod();
	// }, [displayDate]);

	// useEffect(() => {
	// 	getPlanning(dateFrom.format("YYYY-MM-DD"), dateTo.format("YYYY-MM-DD"));
	// }, [dateFrom, dateTo]);

	const onChangePeriod = () => {
		let selectMonth = selectedMonth;
		// if (selectedMonth < 3 && selectedYear == 2025) {
		// 	setSelectedMonth(3);
		// 	selectMonth = 3;
		// }
		today.current = today.current
			.set("month", selectMonth)
			.set("year", selectedYear);
		let dateFrom = today.current.startOf("month");
		let dateTo = today.current.endOf("month");

		let tmpDate = dayjs(dateFrom, "DD/MM/YYYY");

		const days: any = [];
		while (tmpDate.isSameOrBefore(dateTo)) {
			days.push({
				label: tmpDate.format("dd").charAt(0) + " " + tmpDate.format("DD"),
				isSunday: tmpDate.day() === 0,
				isMonday: tmpDate.day() === 1,
				week: tmpDate.week(),
				date: tmpDate.format("YYYY-MM-DD"),
			});
			tmpDate = tmpDate.add(1, "day");
		}

		setDayList(days);
	};

	const renderHoursHeader = () => {
		const hours = [];
		for (let i = 6; i < 22; i++) {
			hours.push(i);
		}

		return hours.map((hour: any, index: number) => {
			return (
				<div
					key={index}
					style={{
						width: 100 / hours.length + "%",
					}}
					className={
						"text-center py-1 text-sm " +
						(index === hours.length - 1 ? "" : "border-r")
					}
				>
					{(hour + "").padStart(2, "0")}
				</div>
			);
		});
	};

	const renderTimeslots = (scheduleDate: any) => {
		const currentShift = shifts.find(
			(sh: any) => sh.name === scheduleDate?.shiftName
		);
		return (
			<div className="relative w-full p-2">
				{scheduleDate ? (
					scheduleDate.isDayOff ? (
						<div
							style={{
								width: "99%",
								backgroundColor: "#ccc",
							}}
							className={`min-h-[100%] text-center font-semibold`}
						>
							{scheduleDate.dayOffType || "Repos"}
						</div>
					) : (
						scheduleDate.timeSlots.map((tSlot: any, index: number) => {
							const fromHourTab = tSlot.fromHour.split(":");
							const toHourTab = tSlot.toHour.split(":");

							const minutesFrom =
								fromHourTab[0] * 60 + parseInt(fromHourTab[1]);
							const minutesTo = toHourTab[0] * 60 + parseInt(toHourTab[1]);
							const diff = Math.abs(minutesTo - minutesFrom) / 60;
							const width = Math.round(diff * (100 / 16));
							const left = Math.round(
								((minutesFrom - 6 * 60) / 60) * (100 / 16)
							);

							return (
								<div
									style={{
										width: `${width}%`,
										top: "2px",
										left: left + "%",
										backgroundColor: currentShift?.color,
									}}
									key={index}
									className={`absolute bg-blue min-h-[100%] text-center text-sm`}
								>
									{tSlot.fromHour} - {tSlot.toHour}
								</div>
							);
						})
					)
				) : null}
			</div>
		);
	};

	const renderEmployeePlanning = () => {
		const key = selectedYear + "-" + (selectedMonth + 1 + "").padStart(2, "0");
		let employeePlanning =
			plannings && plannings[key] && plannings[key].schedule
				? plannings[key].schedule[0]
				: null;


		if (!employeePlanning) {
			employeePlanning = {
				scheduleDays: [],
			};
		}

		return (
			<div
				className={`w-[100%] h-[55px] items-center flex flex-col flex-1 border-b-2 border-neutral-500 border-l-none border-t-none dark:border-slate-700 overflow-hidden z-0`}
			>
				{dayList.map((day: any, indexD: number) => {
					return (
						<div
							key={indexD}
							className={
								"flex flex-row w-full h-[30px] items-center " +
								(indexD < dayList.length - 1 ? "border-b" : "")
							}
						>
							<div className="text-sm font-semibold w-[10%] border-r pl-3">
								{dayjs(day.date).format("dddd DD")}
							</div>

							<div className="flex flex-row w-[90%] relative min-h-[20px]">
								{renderTimeslots(
									employeePlanning?.scheduleDays.find((d: any) => {
										return dayjs(d.dayDate).format("YYYY-MM-DD") === day.date;
									})
								)}
							</div>
						</div>
					);
				})}
			</div>
		);
	};

	return (
		<div className="nc-EmployeePlanning relative overflow-hidden">
			{/* SECTION HERO */}
			{/* <SectionHero2 /> */}

			<div className="container relative my-8 px-14">
				<div>
					<h2 className="text-2xl md:text-3xl font-semibold">Planning</h2>
					<div className="flex flex-row gap-3 mt-2">
						<Select
							className="!w-[150px] rounded-lg border-slate-500"
							onChange={({ target }) => {
								setSelectedMonth(parseInt(target.value));
							}}
							value={selectedMonth}
						>
							{monthList.map((m: any, i: number) => (
								<option value={m.value} key={i}>
									{m.label}
								</option>
							))}
						</Select>
						{yearList.length > 0 && (
							<Select
								className="!w-[100px] rounded-lg border-slate-500"
								onChange={({ target }) => {
									setSelectedYear(parseInt(target.value));
								}}
								value={selectedYear}
							>
								<option></option>
								{yearList.map((y: number, i: number) => {
									return (
										<option value={y} key={i}>
											{y}
										</option>
									);
								})}
							</Select>
						)}
						<ButtonPrimary
							className="rounded-lg"
							disabled={
								(!selectedMonth && selectedMonth !== 0) ||
								(!selectedYear && selectedYear !== 0)
							}
							onClick={() => onChangePeriod()}
						>
							<CheckIcon className="h-5 w-5" />
						</ButtonPrimary>
					</div>
				</div>
				<div className=" relative mb-3">
					<BackgroundSection className="bg-neutral-50/80 dark:bg-black/20" />
					<div className="flex mt-2 justify-end items-start gap-2"></div>
					<div className="flex flex-col py-2 items-center relative">
						<div className="w-[100%]">
							<div className="flex flex-col gap-3 items-center">
								<div className="w-[100%] border-2 border-slate-500 rounded-lg min-h-80">
									<div className="flex flex-row items-center justify-between gap-3 py-3 px-3 bg-white rounded-t-lg border-dashed border-slate-500 border-b-4 rounded-b-none">
										<span className="font-semibold text-lg">
											{today.current.format("MMMM YYYY").toUpperCase()}
										</span>
										{!!employee && (
											<span className="font-semibold text-lg">
												{plannings &&
												plannings.schedule &&
												plannings.schedule[0]
													? plannings.schedule[0].totalHours + " heures"
													: ""}{" "}
												-{" "}
												<span>
													Congés : {employee.soldeConges || 0} / Récup. :
													{employee.soldeRecup || 0}
												</span>
												<InformationCircleIcon
													className="inline-block h-6 w-6 text-slate-900 ml-1 cursor-pointer"
													onClick={() => setShowModalCongesRecup(true)}
												/>
											</span>
										)}
									</div>
									<div className="flex flex-col">
										<div className="flex flex-row border-b-2">
											<div className="w-[10%] border-r"></div>
											<div className="flex flex-row w-[90%] items-center">
												{renderHoursHeader()}
											</div>
										</div>
										{renderEmployeePlanning()}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{showModalCongesRecup && (
				<ModalCongesRecup
					employee={employee}
					show={showModalCongesRecup}
					onCloseModal={() => setShowModalCongesRecup(false)}
				/>
			)}
		</div>
	);
}

export default EmployeePlanning;
